// extracted by mini-css-extract-plugin
module.exports = {"answer":"AnswerBox_answer__fkxj1","name":"AnswerBox_name__3MlMN"};